// Survey sharing configuration - must match backend
// Using a large timestamp-based offset to generate longer, more unique share IDs
export const SURVEY_ID_OFFSET = 1737216000000;

export const QUESTION_TYPES = {
  SINGLE_CHOICE: 'single_choice',
  MULTIPLE_CHOICE: 'multiple_choice',
  YES_NO: 'yes_no',
  RATING_SCALE: 'rating_scale',
  LIKERT_SCALE: 'likert_scale',
  RANKING: 'ranking',
  SHORT_TEXT: 'short_text',
  LONG_TEXT: 'long_text',
  DROPDOWN: 'dropdown',
  NPS: 'nps',
  NUMERIC_INPUT: 'numeric_input',
  IMAGE_HOTSPOT: 'image_hotspot',
  INFO_SCREEN: 'info_screen',
} as const;

export const SURVEY_STATES = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
} as const;

export const SESSION_STATES = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  ABANDONED: 'abandoned',
  PAUSED: 'paused',
} as const;

export const SURVEY_ROUTES = {
  LIST: '/surveys',
  NEW: '/surveys/new',
  DETAILS: '/surveys/:id',
  INTERVIEW: '/interview/:sessionId',
  RESULTS: '/surveys/:id/results',
} as const;

// Respondent identity for surveys fielded without a panel provider. The backend can only
// resume a session it can name, and the only name it accepts is `external_tracking_id` — so a
// survey with no panel tracking param has to bring its own. See features/humanSurvey/respondentId.ts.
export const RESPONDENT_ID_PARAM = 'rid';
export const RESPONDENT_ID_STORAGE_PREFIX = 'survey_respondent_';
